import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/autoplay";

import { Navigation, Autoplay } from "swiper";

import styles from "./index.module.scss";
import { get } from "../../common/request";
import { APIS } from "../../pages/admin/common";

export interface ClassroomProps {}

export function Classroom(props: ClassroomProps) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    get(APIS.EXAM_ENVIRONMENT_LIST).then((res) => {
      setItems(res.data.map((item) => item.imageUrl));
    });
  }, []);

  return (
    <div className={styles.wrapper}>
      <Container>
        <div className={styles["title-wrapper"]}>
          <h2>考场环境</h2>
        </div>

        <div className={styles["items-wrapper"]}>
          <Swiper
            slidesPerView={4}
            spaceBetween={30}
            navigation={{
              nextEl: ".classroom.swiper-button-next",
              prevEl: ".classroom.swiper-button-prev"
            }}
            loop={true}
            // navigation={true}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false
            }}
            modules={[Navigation, Autoplay]}
            breakpoints={{
              200: {
                slidesPerView: 1,
                spaceBetween: 10
              },
              480: {
                slidesPerView: 1,
                spaceBetween: 10
              },
              768: {
                slidesPerView: 2,
                spaceBetween: 20
              },
              1024: {
                slidesPerView: 4,
                spaceBetween: 30
              }
            }}
          >
            {items.map((item, index) => (
              <SwiperSlide key={index}>
                <img src={item} />
              </SwiperSlide>
            ))}
            {/* <SwiperSlide>Slide 1</SwiperSlide>
            <SwiperSlide>Slide 2</SwiperSlide>
            <SwiperSlide>Slide 3</SwiperSlide>
            <SwiperSlide>Slide 4</SwiperSlide>
            <SwiperSlide>Slide 5</SwiperSlide>
            <SwiperSlide>Slide 6</SwiperSlide>
            <SwiperSlide>Slide 7</SwiperSlide>
            <SwiperSlide>Slide 8</SwiperSlide>
            <SwiperSlide>Slide 9</SwiperSlide> */}
          </Swiper>

          <div className="classroom swiper-button-prev"></div>
          <div className="classroom swiper-button-next"></div>
        </div>
      </Container>
    </div>
  );
}
